module.exports = __webpack_public_path__ + "static/media/home.967c1783.svg";